// Billing Utils
export const STRIPE_STATUS = {
  ACTIVE: {
    TRIALING: "trialing",
    ACTIVE: "active"
  },
  INACTIVE: {
    PAST_DUE: "past_due",
    CANCELED: "canceled",
    UNPAID: "unpaid"
  }
}

export const isPartnerCustomer = (customerDetails) => {
  let isPartner = false;

  if (customerDetails && customerDetails.metadata) {
    isPartner = customerDetails.metadata.partner || customerDetails.metadata.partnerId;
  }
  return isPartner;
}

export const partnerBillingUrl = (customerDetails) => {
  let billingUrl = `${process.env.REACT_APP_API_CLIENT_BASE_URL}/billing`;

  if (isPartnerCustomer(customerDetails)) {
    if (customerDetails.metadata.partner.toLowerCase().includes("appsumo")) {
      // get invoice_item_uuid as billing reference
      // https://appsumo.com/account/redemption/<invoice_item_uuid>#change-plan
      const activeSubscription = getActiveSubscriptionFromCustomer(customerDetails, true);
      const invoiceItemUuid = activeSubscription.metadata.invoice_item_uuid;
      billingUrl = `https://appsumo.com/account/redemption/${invoiceItemUuid}#change-plan`;
    }
  }
  return billingUrl;
}

/**
 * Return the first stripe active subscription (active or trialing)
 * Yes, there could be more, but we don't support that at the moment
 * Optionally, include the last inactive (ended) subscription. This is used for picking out
 * the last plan that the customer had.
 * 
 * @see `billing-manager/src/stripe-utils.js#getActiveSubscriptionFromCustomer`
 * @param {Object} customer Stripe customer
 */
 export const getActiveSubscriptionFromCustomer = (customerDetails, includeInactive=false) => {
  const functionName = "getActiveSubscriptionFromCustomer";
  if (!customerDetails || !customerDetails.subscriptions || !customerDetails.subscriptions.data) {
      console.warn("No customer details found");
      return {};
    }
  try {
    let currentSubscription; 
    const activeSubscriptions = customerDetails.subscriptions.data.filter(s => Object.values(STRIPE_STATUS.ACTIVE).includes(s.status)); 
    if (activeSubscriptions && activeSubscriptions.length > 1) {
      console.warn({functionName, activeSubscriptions, warning: "more than one active sub found"});
    }
    // if there are no active subscriptions, then check if we should 
    // return the last inactive subscription 
    if ((!activeSubscriptions || activeSubscriptions.length === 0) && includeInactive) {
      // get the last subscription, so we can figure out the plan
      currentSubscription = getLastSubscriptionFromCustomer(customerDetails);
    } else {
      // just get the first active subscription for now
      currentSubscription = activeSubscriptions[0];
    }
    // return the fist active subscription
    return currentSubscription;
  } catch (error) {
    console.error({functionName, customerDetails, error: error.toString()});
    throw new Error(error);
  }
}

/**
 * Return the last subscription (past due, canceled, unpaid, active or trialing) sorted by end_date
 * Subscriptions are sorted by server
 * @param {Object} customerDetails Stripe customer details
 */
 export const getLastSubscriptionFromCustomer = (customerDetails) => {
  const functionName = "getLastSubscriptionFromCustomer";

  try {
    // first try to get the last inactive subscription
    let subscriptions = [];
    if (customerDetails && customerDetails.subscriptions && customerDetails.subscriptions.data.length > 0) {      
      subscriptions = customerDetails.subscriptions.data.filter(s => Object.values(STRIPE_STATUS.INACTIVE).includes(s.status)); 
    } 
    if (!subscriptions || subscriptions.length === 0) { 
      subscriptions = customerDetails.subscriptionsEnded || [];
    }
    // return the fist active subscription
    const [lastSubscription] = subscriptions;
    return lastSubscription;
  } catch (error) {
    console.error({functionName, customerDetails, error: error.toString()});
    throw new Error(error);
  }
}